import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
export default {
  key: planTypes[planTypes.LDKCMR],
  data () {
    return {
      title: this.$t('billing.planform.title.ldk_cmr'),
      subtitle: '',
      description: this.$t('billing.cmr_ldk.desc', [5]),
      logo: getPlanLogo(planTypes.LDKCMR),
      trackingPlanKey: 'zoom video sdk recording',
      planType: planTypes.LDKCMR,
    }
  }
};
